export const COUNTRIES = [
  { name: "Afghanistan", code: "AF", dialCode: "+93" },
  { name: "Australia", code: "AU", dialCode: "+61" },
  { name: "Bahrain", code: "BH", dialCode: "+973" },
  { name: "Bangladesh", code: "BD", dialCode: "+880" },
  { name: "Canada", code: "CA", dialCode: "+1" },
  { name: "China", code: "CN", dialCode: "+86" },
  { name: "Egypt", code: "EG", dialCode: "+20" },
  { name: "Ethiopia", code: "ET", dialCode: "+251" },
  { name: "France", code: "FR", dialCode: "+33" },
  { name: "Germany", code: "DE", dialCode: "+49" },
  { name: "Ghana", code: "GH", dialCode: "+233" },
  { name: "India", code: "IN", dialCode: "+91" },
  { name: "Indonesia", code: "ID", dialCode: "+62" },
  { name: "Iran", code: "IR", dialCode: "+98" },
  { name: "Iraq", code: "IQ", dialCode: "+964" },
  { name: "Jordan", code: "JO", dialCode: "+962" },
  { name: "Kenya", code: "KE", dialCode: "+254" },
  { name: "Kuwait", code: "KW", dialCode: "+965" },
  { name: "Lebanon", code: "LB", dialCode: "+961" },
  { name: "Libya", code: "LY", dialCode: "+218" },
  { name: "Malaysia", code: "MY", dialCode: "+60" },
  { name: "Morocco", code: "MA", dialCode: "+212" },
  { name: "Nepal", code: "NP", dialCode: "+977" },
  { name: "Nigeria", code: "NG", dialCode: "+234" },
  { name: "Oman", code: "OM", dialCode: "+968" },
  { name: "Pakistan", code: "PK", dialCode: "+92" },
  { name: "Palestine", code: "PS", dialCode: "+970" },
  { name: "Philippines", code: "PH", dialCode: "+63" },
  { name: "Qatar", code: "QA", dialCode: "+974" },
  { name: "Saudi Arabia", code: "SA", dialCode: "+966" },
  { name: "Somalia", code: "SO", dialCode: "+252" },
  { name: "South Africa", code: "ZA", dialCode: "+27" },
  { name: "Sri Lanka", code: "LK", dialCode: "+94" },
  { name: "Sudan", code: "SD", dialCode: "+249" },
  { name: "Syria", code: "SY", dialCode: "+963" },
  { name: "Tanzania", code: "TZ", dialCode: "+255" },
  { name: "Tunisia", code: "TN", dialCode: "+216" },
  { name: "Turkey", code: "TR", dialCode: "+90" },
  { name: "Uganda", code: "UG", dialCode: "+256" },
  { name: "United Arab Emirates", code: "AE", dialCode: "+971" },
  { name: "United Kingdom", code: "GB", dialCode: "+44" },
  { name: "United States", code: "US", dialCode: "+1" },
  { name: "Yemen", code: "YE", dialCode: "+967" },
];

export const COUNTRY_MAP = Object.fromEntries(
  COUNTRIES.map((c) => [c.code, c])
);
